import { useEffect, useState, useContext } from "react";
import profilePic from "../../images/logo.webp";
import InvoiceRightPanel from "../panels/InvoiceRightPanel";
import "../../styling/InvoiceTab.css";
import "../../styling/ClientPortal.css";
import { EventDataContext } from "../EventDataContext";

const InvoiceTab = ({ brandingColours }) => {
  const [invoice, setInvoice] = useState([]);
  const { EventData } = useContext(EventDataContext);

  useEffect(() => {
     setInvoice(EventData?.invoice || {});
  }, [EventData]);

  return (
    <div className="invoiceClientContainer">
      <div className="invoiceClientLeftPanel">
        <div className="invoiceClientTab">
          <div className="invoiceClientTab-inner">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                width: "100%",
                padding: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start"}}>
                {/* <img
                  src={profilePic}
                  alt="Your Image"
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    marginRight: "15px",
                    boxShadow: '0px 2px 6px #00000029'
                  }}
                /> */}
                <div>
                  <div style={{ color: "#000000", fontWeight: "500", fontSize:'15px' }}>Billed By</div>
                  <p style={{ color: "#625C73", marginTop: "7px", marginBottom: "5px", fontSize:'15px'  }}>
                    {invoice?.billedBy?.name}
                  </p>
                  <p style={{ color: "#625C73", marginTop: "0px", fontSize:'15px' }}>
                    {invoice?.billedBy?.email}
                  </p>
                </div>
              </div>

              <div style={{ minWidth: "100px", color: "#625C73" }}>
                <p style={{ fontSize:'15px' }}>
                  Invoice: {invoice?.invoiceNumber} <br />
                  Issued :{" "}
                  {invoice.issuedDate
                    ? new Date(invoice.issuedDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "-"}
                  <br />
                </p>
              </div>
            </div>
          </div>

          <div>
            <div className="invoiceContent">
              <div style={{ color: "#000000", fontWeight: "500" }}>Billed To</div>
              <p style={{ color: "#625C73", marginTop: "7px", marginBottom: "5px" }}>
                {invoice?.billedTo?.name?.split(" ")[0]}
              </p>
              <p style={{ color: "#625C73", marginTop: "0px", marginBottom: "5px" }}>
                {invoice.billedTo?.name?.split(" ")[1] || ""}
              </p>
              <p style={{ color: "#625C73", marginTop: "0px" }}>
                {invoice.billedTo?.email}
              </p>

              <h2 style={{ marginTop: "30px", color: "#000000", fontSize:'20px' }}>Items</h2>

              <div
                className="right-panel-content"
                style={{ marginTop: "0px", padding: "20px" }}
              >
                {invoice.items?.map((item, index) => (
                  <div key={index}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        <p
                          style={{
                            color: "#000000",
                            marginBottom: "-10px",  
                            fontWeight: "500",
                            fontSize:'20px'
                          }}
                        >
                          {item.name}
                        </p>
                      </span>
                      <p
                        style={{
                          color: "#000000",
                          marginBottom: "-10px",  
                          fontWeight: "500",
                          fontSize:'15px',
                        }}
                      >
                        ${item.amount}
                      </p>
                    </div>
                    
                    {/* UPDATED: Bulletproof Hyphen Stripper and Renderer */}
                    <div style={{ color: "#625C73", marginTop: "15px" }}>
  {(item?.description || "")
    .split(/\n/) // FIX: Only split on new lines, never on hyphens inside a sentence
    .filter(f => f.trim() !== "")
    .map((feature, i) => {
      // Scrubs away any leftover leading hyphens or bullets before rendering
      const cleanText = feature.trim().replace(/^[-*•]\s*/, "");
      
      return (
        <p key={i} style={{ margin: "3px 0", fontSize: "15px" }}>
          {cleanText}
        </p>
      );
    })}
</div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  borderBottom: "1px solid #D9D9D9",
                  color: "#625C73",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "1.3%",
                }}
              >
                <div>Subtotal</div>
                <div style={{ width: "20%" }}></div>
                <div>${invoice.subtotal}</div>
              </div>
              <div
                style={{
                  borderBottom: "1px solid #D9D9D9",
                  color: "#625C73",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "1.3%",
                }}
              >
                <div>Total</div>
                <div style={{ width: "20%" }}></div>
                <div>${invoice.total}</div>
              </div>
              <div
                style={{
                  color: "#625C73",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "1.3%",
                }}
              >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="invoiceClientRightPanel">
        <InvoiceRightPanel brandingColours={brandingColours} invoiceDetail={invoice} event={EventData} />
      </div>
    </div>
  );
};

export default InvoiceTab;